import { CSSObject } from '@emotion/react';
import { zIndex } from 'styles';
import * as InputStyle from '../Input/style/default';

const wrap: CSSObject = {
  display: 'flex',
  minWidth: '130px',
  position: 'relative',
  height: '40px',
  input: { ...InputStyle.wrap, height: '40px', width: '100%' },

  '.react-datepicker-wrapper': {
    width: '100%',
  },

  '.react-datepicker-popper': {
    zIndex: zIndex.DATEPICKER,
  },
};

export { wrap };
